import WindCreekStorage from './WindCreekStorage.mjs';

/*
If the query string contains mobileapp=true, hide the header, footer, etc. This query parameter is used on links that
open within the WC mobile app. Also, store this setting so it will keep this view even if the user navigates to other
pages (and the query parameter is lost).
*/

// Exit the app view if mobileapp=false is passed in the query parameters
if (location.search.toLowerCase().match(/mobileapp=false/) !== null) {
  WindCreekStorage.removeItem('mobile_app_view');
}

if (location.search.toLowerCase().match(/mobileapp=true/) !== null || WindCreekStorage.exists('mobile_app_view')) {
  document.querySelector('body').classList.add('app-view');
  WindCreekStorage.setItem('mobile_app_view', 'true', true);

  document.querySelectorAll('a[data-disable-in-app-view]').forEach(element => {
    element.tabIndex = '-1';
    element.removeAttribute('href');
    element.addEventListener('click', event => event.preventDefault());
  });
}
